import cookie from 'js-cookie'
import { IS_LOCAL } from 'src/config'
const { get, set, remove } = cookie

export type TokenStore = {
  getToken: (name: string) => string | undefined
  setToken: (name: string, value: string, expires: Date) => void
  clearToken: (name: string) => void
}

type CookieStoreParams = {
  path: string
  domain: string
}

export class CookieStore {
  private readonly path: string
  private readonly domain: string | undefined

  constructor(params: CookieStoreParams) {
    this.path = params.path
    this.domain = params.domain === 'localhost' ? undefined : params.domain
  }

  getToken(name: string) {
    return get(name)
  }

  setToken(name: string, value: string, expires: Date) {
    set(name, value, { expires, sameSite: 'strict', path: this.path, domain: this.domain, secure: !IS_LOCAL })
  }

  clearToken(name: string) {
    remove(name, { path: this.path, domain: this.domain })
  }
}

export class MemoryStore {
  private readonly map = new Map<string, string>()
  getToken(name: string): string | undefined {
    return this.map.get(name)
  }

  setToken(name: string, value: string, expires: Date) {
    this.map.set(name, value)
  }

  clearToken(name: string) {
    this.map.delete(name)
  }
}
